// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2yWdR","inputWrap":"styles_inputWrap__3BTKk","input":"styles_input__Y4xzO"};